import Quickview from './Quickview';
import i18next from 'i18next';
import { useState } from 'react';
import { fileNotFound } from '../../assets/images/icons';
import { useTranslation } from 'react-i18next';
import { hasDiscount } from "../../utils/hasDiscount";

export default function ProductCard({ item }) {
  const { t } = useTranslation();
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;

  const imgs = item.imgs || [];
  const [imgError, setImgError] = useState(false);

  const firstImg = imgs[0] ? localimg + imgs[0] : fileNotFound;
  const secondImg = imgs[1] ? localimg + imgs[1] : null;

  let isThisAvailable = true;
  if (item.total_stock && parseInt(item.total_stock) > 0) {
    isThisAvailable = true;
  } else if (item.is_nouvel_arrivage === 1 && item.is_nouvel_arrivage_available === 0) {
    isThisAvailable = true;
  } else {
    isThisAvailable = false;
  }

  return (
    <div className="group">
      {/* Image tile — light studio background, hover reveals the second shot */}
      <div className="relative aspect-square overflow-hidden bg-[#ebe9e7]">
        <a href={`/product/${item.slug}`} className="block w-full h-full">
          <img
            loading="lazy"
            src={imgError ? fileNotFound : firstImg}
            onError={() => setImgError(true)}
            alt={item.name?.[i18next.language] || 'product'}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${secondImg ? 'group-hover:opacity-0' : ''} ${!isThisAvailable ? 'blur-[2px] scale-105' : ''}`}
          />
          {secondImg && (
            <img
              loading="lazy"
              src={secondImg}
              alt=""
              className={`absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100 ${!isThisAvailable ? 'blur-[2px] scale-105' : ''}`}
            />
          )}
        </a>

        {/* New-arrival tag */}
        {item.is_nouvel_arrivage === 1 && (
          <span className="absolute left-3 top-3 z-10 rounded-full bg-black px-2 py-1 text-[9px] sm:text-[10px] font-semibold uppercase tracking-wider text-white">
            {t('new-arrival')}
          </span>
        )}

        {/* Quick-view eye — top right */}
        {isThisAvailable && (
          <div className="absolute right-2 top-2 z-10 opacity-100 lg:opacity-0 lg:group-hover:opacity-100 transition-opacity duration-300">
            <Quickview slugProduct={item.slug} smallBtn />
          </div>
        )}

        {/* Out of stock — blurred image + centered label */}
        {!isThisAvailable && (
          <div className="absolute inset-0 z-10 flex items-center justify-center">
            <span className="text-xs sm:text-sm font-semibold uppercase tracking-widest text-black">
              {t('out-of-stock')}
            </span>
          </div>
        )}
      </div>

      {/* Title + price */}
      <div className="mt-3">
        <a href={`/product/${item.slug}`} className="block">
          <h3 className="text-[13px] sm:text-[15px] font-semibold leading-snug text-gray-900 hover:opacity-70 transition-opacity">
            {item.name?.[i18next.language]}
          </h3>
        </a>
        <div className="mt-1 flex items-baseline gap-2">
          {hasDiscount(item) ? (
            <>
              <span className="text-[13px] sm:text-sm text-gray-400 line-through">{item.old_price} MAD</span>
              <span className="text-[13px] sm:text-sm font-medium text-gray-900">{item.price} MAD</span>
            </>
          ) : (
            <span className="text-[13px] sm:text-sm font-medium text-gray-900">{item.price} MAD</span>
          )}
        </div>
      </div>
    </div>
  );
}
